export { REFRESH_TOKEN_STORAGE_KEY } from '@/contexts/auth/storage-keys'

export const MAX_FILE_SIZE = 5 * 1024 * 1024 // 5MB
export const MAX_FILE_SIZE_IN_MB = MAX_FILE_SIZE / 1024 / 1024
export const ACCEPTED_IMAGE_TYPES = ['image/png', 'image/jpeg']

export const CARD_ASPECT_RATIO = 400 / 140
export const AVATAR_ASPECT_RATIO = 1 / 1
